var SENTRY_RELEASE;SENTRY_RELEASE={name: "fytness", version: "1.1.3"};